import { createAction, props } from '@ngrx/store';
import { Ailment, Diagnostic, DoctorSpecialization, Hospitalization, Pharmacy, StaticReason } from 'src/models/module-wise/inventory/inventory';

export const startInventoryFetch = createAction(
  '[INVENTORY] Fetching Start'
);

export const stopInventoryFetch = createAction(
  '[INVENTORY] Fetching Stop'
);

export const paginateInventory = createAction(
  '[INVENTORY] Paginating'
);

/** DOCTOR SPECIALIZATIONS  */
export const loadDoctorSpecialization = createAction(
  '[DOCTOR SPECIALIZATIONS] Load Doctor Specialization',
  props<{ payload: DoctorSpecialization[], totalDocuments: number }>()
);

export const addDoctorSpecialization = createAction(
  '[DOCTOR SPECIALIZATIONS] Add Doctor Specialization',
  props<{ payload: DoctorSpecialization }>()
);

export const editDoctorSpecialization = createAction(
  '[DOCTOR SPECIALIZATIONS] Edit Doctor Specialization',
  props<{ payload: DoctorSpecialization | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeDoctorSpecializations = createAction(
  '[DOCTOR SPECIALIZATIONS] Delete Doctor Specialization',
  props<{ payload: string[] }>()
);

export const removeAllDoctorSpecializations = createAction(
  '[DOCTOR SPECIALIZATIONS] Remove All Doctor Specializations'
);

/** AILMENTS */
export const loadAilments = createAction(
  '[ AILMENT ] Load ailment',
  props<{ payload: Ailment[], totalDocuments: number }>()
);

export const addAilment = createAction(
  '[ AILMENT ] Add ailment',
  props<{ payload: Ailment }>()
);

export const editAilment = createAction(
  '[ AILMENT ] Edit ailment',
  props<{ payload: Ailment | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeAilments = createAction(
  '[ AILMENT ] Delete ailment',
  props<{ payload: string[] }>()
);

export const removeAllAilments = createAction(
  '[ AILMENT ] Remove All ailments'
);

/** LAB TESTS */
export const loadLabTest = createAction(
  '[ LAB TEST ] Load Lab Test',
  props<{ payload: Diagnostic[], totalDocuments: number }>()
);

export const addLabTest = createAction(
  '[ LAB TEST ] Add Lab Test',
  props<{ payload: Diagnostic }>()
);

export const editLabTest = createAction(
  '[ LAB TEST ] Edit Lab Test',
  props<{ payload: Diagnostic | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeLabTests = createAction(
  '[ LAB TEST ] Delete Lab Test',
  props<{ payload: string[] }>()
);

export const removeAllLabTests = createAction(
  '[ LAB TEST ] Remove All Lab Test'
);

/** LAB TESTS PACKAGES */
export const loadLabTestPackages = createAction(
  '[ LAB TEST PACKAGE ] Load Lab Test Package',
  props<{ payload: Diagnostic[], totalDocuments: number }>()
);

export const addLabTestPackage = createAction(
  '[ LAB TEST PACKAGE ] Add Lab Test Package',
  props<{ payload: Diagnostic }>()
);

export const editLabTestPackage = createAction(
  '[ LAB TEST PACKAGE ] Edit Lab Test Package',
  props<{ payload: Diagnostic | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeLabTestPackages = createAction(
  '[ LAB TEST PACKAGE ] Delete Lab Test Package',
  props<{ payload: string[] }>()
);

export const removeAllLabTestPackages = createAction(
  '[ LAB TEST PACKAGE ] Remove All Lab Test Package'
);

/** HOSPITALIZATIONS */
export const loadHospitalizations = createAction(
  '[ HOSPITALIZATION ] Load Hospitalization',
  props<{ payload: Hospitalization[], totalDocuments: number }>()
);

export const addHospitalization = createAction(
  '[ HOSPITALIZATION ] Add Hospitalization',
  props<{ payload: Hospitalization }>()
);

export const editHospitalization = createAction(
  '[ HOSPITALIZATION ] Edit Hospitalization',
  props<{ payload: Hospitalization | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeHospitalizations = createAction(
  '[ HOSPITALIZATION ] Delete Hospitalization',
  props<{ payload: string[] }>()
);

export const removeAllHospitalizations = createAction(
  '[ HOSPITALIZATION ] Remove All Hospitalization'
);

/** STATIC REASONS */
export const loadStaticReasons = createAction(
  '[ STATIC REASON ] Load Static reason',
  props<{ payload: StaticReason[], totalDocuments: number }>()
);

export const addStaticReason = createAction(
  '[ STATIC REASON ] Add Static reason',
  props<{ payload: StaticReason }>()
);

export const editStaticReason = createAction(
  '[ STATIC REASON ] Edit Static reason',
  props<{ payload: StaticReason | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removeStaticReasons = createAction(
  '[ STATIC REASON ] Delete Static reason',
  props<{ payload: string[] }>()
);

export const removeAllStaticReasons = createAction(
  '[ STATIC REASON ] Remove All Static reason'
);

/** PHARMACY TESTS */
export const loadPharmacyTest = createAction(
  '[ PHARMACY TEST ] Load Pharmacy Test',
  props<{ payload: Pharmacy[], totalDocuments: number }>()
);

export const addPharmacyTest = createAction(
  '[ PHARMACY TEST ] Add Pharmacy Test',
  props<{ payload: Pharmacy }>()
);

export const editPharmacyTest = createAction(
  '[ PHARMACY TEST ] Edit Pharmacy Test',
  props<{ payload: Pharmacy | { status: string, _id: string } | { isGeneral: boolean, _id: string } }>()
);

export const removePharmacyTest = createAction(
  '[ PHARMACY TEST ] Delete Pharmacy Test',
  props<{ payload: string[] }>()
);

export const removeAllPharmacyTest = createAction(
  '[ PHARMACY TEST ] Remove All Pharmacy Test'
);

